import { SupplierContactData } from '../../components/SupplierContactForm/SupplierContactForm.schema';
import { SvbrgIntakeRequestSupplier, SvbrgIntakeRequestSupplierInput, SvbrgLanguage } from '@/generated/gql/graphql';

export const gridDataToSupplier = (row: SupplierContactData): SvbrgIntakeRequestSupplierInput => {
  return {
    contact: {
      firstName: row.supplier.contact.firstName,
      lastName: row.supplier.contact.lastName,
      email: row.supplier.contact.email,
      internalId: row.supplier.contact.internalId,
      language: row.supplier.contact.language as SvbrgLanguage,
    },
    internalId: row.supplier.internalId,
    isQuoted: row.supplier.isQuoted,
    source: row.supplier.source || undefined,
    reason: row.supplier.reason || undefined,
    location: {
      address: row.supplier.location.address,
      city: row.supplier.location.city,
      postalCode: row.supplier.location.postalCode,
      countryCode: row.supplier.location.countryCode,
      internalId: row.supplier.location.internalId,
    },
  };
};

export const apiToSupplier = (supplier: SvbrgIntakeRequestSupplier): SupplierContactData => {
  return {
    id: supplier.id,
    supplier: {
      contact: {
        firstName: supplier.contact?.firstName || '',
        lastName: supplier.contact?.lastName || '',
        email: supplier.contact?.email || '',
        internalId: supplier.contact?.internalId || '',
        language: supplier.contact?.language || '',
      },
      internalId: supplier.internalId,
      isQuoted: supplier.isQuoted,
      source: supplier.source || null,
      reason: supplier.reason || null,
      location: {
        address: supplier.location?.address || null,
        city: supplier.location?.city || null,
        postalCode: supplier.location?.postalCode || null,
        countryCode: supplier.location?.countryCode || null,
        internalId: supplier.location?.internalId || '',
      },
    },
  };
};
